import PropTypes from "prop-types";
import { memo } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import AddressTreeViewSelect from "./AddressTreeViewSelect";

const useStyles = makeStyles(theme => ({
  pageTitle: {
    color: theme.palette.component.productBoxColor,
    fontWeight: 600,
    fontSize: 16,
    marginTop: 0,
    display: "inline-block",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 5,
    },
  },
  selectLabel: {
    marginBottom: 5,
    fontSize: 12,
  },
  infoLink: {
    fontSize: 12,
    color: theme.palette.common.link,
    marginRight: 5,
    "&:hover": {
      color: theme.palette.common.link,
      opacity: 0.8,
    },
  },
  infoIcon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 14,
    verticalAlign: "bottom",
  },
  selectAddressWrap: {
    borderBottom: "1px solid #ddd",
    paddingBottom: 20,
    marginBottom: 20,
  },
}));

const DeliveryInfoHeader = ({
  addressOptions,
  handleAddressChange,
  hideAddressDropdown,
  selectedAddressField,
}) => {
  const classes = useStyles();

  const buildTree = (treeData) => {

    const lookup = {};
    const tree = [];

    treeData.forEach(item => {
      lookup[item.id] = { ...item, children: [] };
    });

    treeData.forEach(item => {
      if (item.parentId === null) {
        tree.push(lookup[item.id]);
      } else {
        lookup[item.parentId]?.children.push(lookup[item.id]);
      }
    });

    return tree;
  };

  const addressTree = buildTree(addressOptions);

  return (
    <Grid
      container
      spacing={0}
      direction="row"
      align-items="center"
      className={classes.selectAddressWrap}
    >
      {!hideAddressDropdown && addressOptions.length > 0 && (
        <>
          <Grid item xs={12} sm={8}>
            <AddressTreeViewSelect
              addressOptions={addressOptions}
              treeData={addressTree}
              onSelect={handleAddressChange}
              selectedAddressField={selectedAddressField}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

DeliveryInfoHeader.defaultProps = {
  selectedAddressField: null,
  hideEmptyCartButton: false,
  hideAddressDropdown: false,
};

DeliveryInfoHeader.propTypes = {
  addressOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      label: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    })
  ).isRequired,
  handleAddressChange: PropTypes.func.isRequired,
  handleRemoveAllProducts: PropTypes.func.isRequired,
  selectedAddressField: PropTypes.string,
  hideEmptyCartButton: PropTypes.bool,
  hideAddressDropdown: PropTypes.bool,
};

function areEqual(prevProps, nextProps) {
  if (
    nextProps.selectedAddressField !== prevProps.selectedAddressField ||
    nextProps.addressOptions !== prevProps.addressOptions
  ) {
    return false;
  }
  return true;
}

export default memo(DeliveryInfoHeader, areEqual);
